import { HelpHintWindow } from "@/components/ui/HintWindow";
import { PanelGrid } from "@/components/ui/Panel";
import { PortfolioOverviewContextPanel } from "@/components/portfolio/portfolio-page/PortfolioOverviewContextPanel";
import { PortfolioOverviewCreatePanel } from "@/components/portfolio/portfolio-page/PortfolioOverviewCreatePanel";
import { PortfolioOverviewIntroPanel } from "@/components/portfolio/portfolio-page/PortfolioOverviewIntroPanel";
import { useLanguage } from "@/context/LanguageContext";

export type PortfolioTopHintWindowProps = {
  estateCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
  isOpen: boolean;
  onToggle: () => void;
};

type PortfolioHintWindowBodyPanelsProps = {
  estateCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
};

function PortfolioHintWindowBodyPanels({
  estateCount,
  activeViewLabel,
  activeViewDescription,
}: PortfolioHintWindowBodyPanelsProps) {
  return (
    <PanelGrid className="xl:grid-cols-3">
      <PortfolioOverviewIntroPanel />
      <PortfolioOverviewContextPanel
        estateCount={estateCount}
        activeViewLabel={activeViewLabel}
        activeViewDescription={activeViewDescription}
      />
      <PortfolioOverviewCreatePanel />
    </PanelGrid>
  );
}

export function PortfolioTopHintWindow({
  estateCount,
  activeViewLabel,
  activeViewDescription,
  isOpen,
  onToggle,
}: PortfolioTopHintWindowProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      help: "Nápověda",
      title: "Tipy k portfoliu",
      description: "Kontext, přehled a rychlá správa nad hlavním obsahem.",
      hideHelp: "Skrýt nápovědu",
    },
    en: {
      help: "Help",
      title: "Portfolio tips",
      description:
        "Context, overview, and quick management above the main content.",
      hideHelp: "Hide help",
    },
  }[language];

  if (!isOpen) return null;

  return (
    <HelpHintWindow
      eyebrow={copy.help}
      title={copy.title}
      description={copy.description}
      closeLabel={copy.hideHelp}
      onClose={onToggle}
    >
      <PortfolioHintWindowBodyPanels
        estateCount={estateCount}
        activeViewLabel={activeViewLabel}
        activeViewDescription={activeViewDescription}
      />
    </HelpHintWindow>
  );
}
